import {useNavigation} from '@react-navigation/native'
import {StackNavigationProp} from '@react-navigation/stack'
import {MainStackParamList} from 'src/nav/MainStackParamsList'

export function useMainNavigator() {
  return useNavigation<StackNavigationProp<MainStackParamList>>()
}
